"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OperationsData',
  data: function data() {
    return {
      loading: false,
      list: [],
      listQuery: {
        page: 0,
        sel_agent_level: 0,
        date_range: []
      }
    };
  },
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    },
    agentInfo: function agentInfo() {
      return this.$store.state.user.agentInfo;
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var url = 'agentapi/my_total_business_data';
      var params = _objectSpread({}, this.listQuery);
      if (this.listQuery.date_range && this.listQuery.date_range.length === 2) {
        params.start_date = this.listQuery.date_range[0];
        params.end_date = this.listQuery.date_range[1];
        delete params.date_range;
      }
      this.loading = true;
      this.$get(url, params).then(function (res) {
        _this.list = res.list;
        _this.listQuery.page = res.page_num;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleDateChange: function handleDateChange() {
      this.getList();
    },
    selDataType: function selDataType(val) {
      this.listQuery.sel_agent_level = val;
      this.getList();
    }
  }
};